export default __webpack_public_path__ + "static/media/close.b0887289.svg";